import { DeleteCell } from './DeleteCell';
import { EditCell } from './EditCell';

export const TableCellsWithPermissions = {
  DeleteCell,
  EditCell,
};
